var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolatilityDecreasing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.476 6.25a1.25 1.25 0 00-1.254.997L2.776 23.914a1.25 1.25 0 002.448.506l2.056-9.943 2.87 18.217a1.25 1.25 0 002.462.045l3.003-15.435 3.44 10.813a1.25 1.25 0 002.364.052l3.02-8.212 2.11 3.645c.283.49.86.728 1.406.581l3.916-1.052 3.482 2.105a1.25 1.25 0 001.294-2.139l-3.939-2.381a1.25 1.25 0 00-.97-.138l-3.506.942-2.965-5.122a1.25 1.25 0 00-2.256.195l-2.68 7.29-3.817-12a1.25 1.25 0 00-2.418.14L11.514 25.29 8.681 7.305A1.25 1.25 0 007.476 6.25z"
  })));
}
export default SvgVolatilityDecreasing;